<template>
	<div class="auth d-flex justify-content-center align-items-center">
		<div class="auth__form theme-bg">
			<h3 class="py-2 pl-4 auth__form__heading text-light">
				Sign <span class="auth__form__heading--span-highlight">In</span>
			</h3>
			<form @submit.prevent="login('emailmsg')">
				<vs-input
					v-model.trim="loginData.email"
					color="#FAF7FD"
					class="auth__input-parent my-45"
					required
					@blur="
						debouncedUniquenessValidation(
							'email',
							loginData.email,
							'existance'
						)
					"
					:style="
						errors.email
							? '--vs-color: 255,71,87;'
							: '--vs-color: 255,255,255;'
					"
					type="email"
					label-placeholder="Email"
					icon-after
				>
					<template #icon>
						<i class="fa fa-envelope"></i>
					</template>
					<template v-if="errors.email" #message-danger>
						{{ errors.email }} You should
						<router-link class="light-link" :to="{ name: 'login' }"
							>register</router-link
						>
						first.
					</template>
				</vs-input>
				<vs-input
					v-model.trim="loginData.password"
					color="#FAF7FD"
					required
					:visible-password="passwordVisible"
					class="auth__input-parent auth__input-parent--password my-45"
					label-placeholder="Password"
					type="password"
					icon-after
				>
					<template #icon>
						<button
							class="plain-btn"
							type="button"
							tabindex="-1"
							@click="passwordVisible = !passwordVisible"
						>
							<transition mode="out-in" name="v-scaled">
								<i
									key="locked"
									v-if="!passwordVisible"
									class="fa fa-lock"
								>
								</i>
								<i key="open" v-else class="fa fa-lock-open">
								</i>
							</transition>
						</button>
					</template>
					<template v-if="submitError" #message-danger>
						{{ submitError }}
					</template>
				</vs-input>
				<div
					class="auth__form__extra-action mb-3 text-light d-flex justify-content-end align-items-center"
				>
					<span class="auth__form__extra-action__forgot-password"
						><router-link
							:to="{ name: 'forgot-password' }"
							class="light-link"
						>
							Forgot Password?
						</router-link></span
					>
				</div>
				<vs-button
					size="large"
					color="#362EB8"
					type="submit"
					class="d-block m-auto w-50"
				>
					Login
				</vs-button>

				<div
					class="auth__form__extra-action mt-3 text-center text-light"
				>
					<span
						>New here?

						<router-link
							class="light-link"
							:to="{ name: 'register' }"
							>Create New Account</router-link
						>
					</span>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex"
import notifier from "@/components/mixins/notifier"
import uniquenessValidation from "@/components/mixins/uniquenessValidation"
import submitError from "@/components/mixins/authError"

export default {
	mixins: [notifier, uniquenessValidation(200), submitError],
	data: () => ({
		passwordVisible: false,
		loginData: {
			email: "",
			password: ""
		}
	}),

	methods: {
		...mapActions("login", ["LOGIN_USER"]),
		async login() {
			const { success, activateFirst, msg } = await this.LOGIN_USER(
				this.loginData
			).catch(this.handleSubmitError)

			if (activateFirst && success) {
				this.openNotification("Account Activation", msg)
				return this.$router.push({ name: "activate-account" })
			} else if (success) {
				this.openNotification("Sign In", msg)
				return this.$router.push({ name: "index" })
			}
		}

		// async login() {
		// 	const { success, activateFirst, msg } = await this.loginRequest()
		// 	if (activateFirst && success) {
		// 		this.openNotification("Account Activation", msg)
		// 		return this.$router.push({ name: "activate-account" })
		// 	} else if (success) {
		// 		this.openNotification("Sign In", msg)
		// 		return this.$router.push({ name: "index" })
		// 	} else {
		// 		this.credentialsError = msg
		// 	}
		// }
	}
}
</script>

<style></style>
